import { useState } from "react";
import { useMsal } from "@azure/msal-react";
import { Switch } from "@mantine/core";
import { IconWand } from "@tabler/icons-react";
import { DEFAULT_PILLOW_VARIANT, generatePillow } from "../api/pillows";
import type { PillowDetail } from "../types/api";
import GenerateForm from "../components/generate/GenerateForm";
import GenerateResult from "../components/generate/GenerateResult";
import PillowVariantFields from "../components/generate/PillowVariantFields";
import { pillowPresenter } from "../components/models/presenters";

export default function GeneratePage() {
  const { instance } = useMsal();
  const [variant, setVariant] = useState(DEFAULT_PILLOW_VARIANT);
  const [forceGenerate, setForceGenerate] = useState(false);
  const [result, setResult] = useState<PillowDetail | null>(null);

  return (
    <GenerateForm
      description="Pillows"
      submitLabel="Generate"
      submitIcon={<IconWand size={16} />}
      busyMessage="Processing… this may take a while"
      onFileChange={() => setResult(null)}
      onSubmit={async (file) => {
        setResult(null);
        setResult(await generatePillow(instance, file, variant, forceGenerate));
      }}
      result={result && <GenerateResult data={result} presenter={pillowPresenter} detailPath={`/gallery/pillows/${result.id}`} />}
    >
      <PillowVariantFields value={variant} onChange={setVariant} />
      <Switch
        label="Force generate"
        description="Re-generate even if a result already exists for this image and colour"
        checked={forceGenerate}
        onChange={(e) => setForceGenerate(e.currentTarget.checked)}
      />
    </GenerateForm>
  );
}
